export default __webpack_public_path__ + "static/media/slider_nw.790cac85.png";